import Backbone from 'backbone';
import Promise from 'bluebird';
import $ from 'jquery';
import _ from 'underscore';
import { CardPanel } from '@bingads-webui/card-panel';
import { PageReady } from '@bingads-webui/page-ready';
import { ToolbarView } from '@bingads-webui/toolbar';
import { fetchMCCOverview } from '@bingads-webui-campaign/overview-cards-common';
import { dismissPopupIfExist } from '@bingads-webui-campaign/fluctuation-common';
import edm from '@bingads-webui-component-legacy/edm-campaign/index';
import config from '@bingads-webui-component-legacy/config/index';
import constants from '@bingads-webui-static-legacy/instrumentation/constants';
import instrumentation from '@bingads-webui-static-legacy/instrumentation/index';
import pageContext from '@bingads-webui-static-legacy/page-context';
import odata from '@bingads-webui-component-legacy/http/channel/odata';
import preference from '@bingads-webui-component-legacy/preference/service/index';
import { appendLearnMoreLink } from '@bingads-webui-component-legacy/help/index';
import state from '@bingads-webui-component-legacy/state/index';
import wunderbarState from '@bingads-webui-static-legacy/wunderbar/controls/wunderbar-state';
import instrumentationSettings from '@bingads-webui-static-legacy/instrumentation/campaignSchemaAndSetting';
import jsdata from '@bingads-webui-component-legacy/js-data-campaign/index';
import dateUtil from '@bingads-webui-component-legacy/humanize/date';
import legacyRouter from '@bingads-webui-component-legacy/legacy-router/index';
import logger from '@bingads-webui-campaign-legacy/instrumentation/index';
import azureUrlRewrite from '@bingads-webui-static-legacy/app/component/azureUrlRewrite';
import cacheManager from '@bingads-webui-campaign-legacy/cache-manager/index';
import eventDispatcher from '@bingads-webui-component-legacy/event-dispatcher/index';
import { buildLegacyI18n } from '@bingads-webui/build-legacy-i18n';

import { getQuickInstrumentation } from '../instrumentation/log-helper';
import { CardState } from './card-state';
import template from './dashboard-template.pug';
import { DateFilterState } from './datefilter-state';
import footerTemplate from './footer-template.pug';
import newFeatureTemplate from './new-feature-template.pug';
import newTileBannerTemplate from './new-tile-banner-template.pug';
import tooManyAccountTemplate from './too-many-accounts-warning.pug';
import { getViewportCardCount, newUIWidthPaddingsAndOffSet } from './util';
import { i18nMappings } from './i18nMappings';


const i18n = window.globalLegacyI18n.get('component/i18n/loader!campaignui/feature/dashboard-page');
const i18nGlobal = window.globalLegacyI18n.get('component/i18n/loader!legacy/global');
const preferences = preference;
const localInstrumentation = logger;

const permissions = config.get('Permissions') || {};
const quickInstrumentation = getQuickInstrumentation({
  instrumentationSettings,
  instrumentation,
  constants,
});

/* @this Dashboard */
function saveSelectedCardsState() {
  const orders = _.map(this.cardPanel.cardsOrder, (id) => {
    const option = { id: this.cardMaps[id].typeId };

    if (this.cardMaps[id].sizeOption) {
      _.extend(option, { sizeOption: this.cardMaps[id].sizeOption });
    }

    if (this.cardMaps[id].options) {
      _.extend(option, { options: this.cardMaps[id].options });
    }
    return option;
  });

  this.cardState.save({
    newCards: orders,
  });
}

/* @this Dashboard */
function contentReady(id) {
  if (!_.isEmpty(this.remainingViewportCards)) {
    this.remainingViewportCards = _.reject(this.remainingViewportCards, card => card === id);

    if (_.isEmpty(this.remainingViewportCards)) {
      this.perfMarker.done({ ViewportCardCount: this.viewportCardsCount });
      PageReady.pageIsReady(this.pageName);
    }
  }
}

/* @this Dashboard */
function createCardContentInstance(contentConstructor, attributes) {
  let content;
  const { name, constructOptions } = attributes;
  const otherOptions = _.extend(_.omit(attributes, 'constructOptions', 'name'), {
    preexecuteFlag: this.preexecuteFlag,
    accountsMode: this.accountsMode,
  });

  if (_.isFunction(constructOptions)) {
    const cardCreationOptions = constructOptions.call(this, {
      navigationLevel: this.navigationLevel,
      campaignType: this.campaignType,
    });

    // eslint-disable-next-line new-cap
    content = new contentConstructor(_.extend(
      otherOptions,
      { name: `${this.navigationLevel}-${name}`, perfMarker: this.perfMarker }, cardCreationOptions.constructOptions
    ));
  } else {
    // eslint-disable-next-line new-cap
    content = new contentConstructor(_.extend(otherOptions, { name: `${this.navigationLevel}-${name}`, perfMarker: this.perfMarker }, constructOptions))
      .setState();
  }

  content.on('storeCardPreference', (cardOptions = {}) => {
    const currentCard = _.find(this.cardMaps, card => card.content === content);

    if (currentCard) {
      currentCard.options = cardOptions;
      _.defer(saveSelectedCardsState.bind(this));
    }
  });

  content.on('saveDashBoardOptions', (newOptions) => {
    _.defer(() => {
      this.cardState.save({ newOptions });
    });
  });

  content.on('clearDragAndDrop', () => this.cardPanel.clearDragAndDrop());
  content.on('setupDragAndDrop', () => this.cardPanel.setupDragAndDrop());
  content.on('cardReady', id => contentReady.call(this, id));

  return content;
}

/* @this Dashboard */
function scrollToAddCardView() {
  _.defer(() => {
    if (this.addCardView &&
      this.addCardView.$el &&
      this.addCardView.$el[0].getBoundingClientRect().y < 0) {
      this.$el.closest('html').animate({ scrollTop: 0 });
    }
  });
}

/* @this Dashboard */
function showAddCardView({ fromTile = false }) {
  eventDispatcher.trigger('overview_loaded');

  if (this.addCardView) {
    if (fromTile) {
      scrollToAddCardView.call(this);
    }
  } else {
    import(/* webpackMode: 'eager' */'@bingads-webui-campaign-react/panel-decorator').then(({ panelDecorator }) => {
      import(/* webpackMode: 'eager' */'./add-card/index').then(({ AddCardView }) => {
        const AddCardPanel = panelDecorator(AddCardView, {
          width: 940,
          panelClassName: 'overview-add-card-panel',
          i18n,
          panelReadyAriaLabel: i18n.getString('Dashboard add card side panel opened'),
        });
        const closeAddCardPanel = () => {
          this.addCardView.remove();
          this.addCardView = null;
        };

        this.addCardView = new AddCardPanel({
          title: i18n.getString('Dashboard_AddCard'),
          selectedCards: _.pluck(this.cardMaps, 'typeId'),
          accountsMode: this.accountsMode,
          newCardsConfig: this.getCardsConfig,
          navigationLevel: this.navigationLevel,
          campaignType: this.campaignType,
          eventsToActions: [{
            event: 'cancel',
            action: closeAddCardPanel,
          }, {
            event: 'apply',
            action: ({
              idsToAdd,
              idsToDelete,
            }) => {
              this.addCardView.remove();
              this.addCardView = null;

              this.addCard(idsToAdd);
              this.deleteCard(idsToDelete);

              if (!_.isEmpty(idsToAdd)) {
                quickInstrumentation('AddTileToOverviewFromPanel');
              }
            },
          }],
          onClose: closeAddCardPanel,
          newI18n: this.newI18n,
        });

        this.addCardView.render();
      });
    });
  }
}

/* @this Dashboard */
function setUpAgents() {
  // Setup date filter service
  if (this.dateFilterState) {
    this.dateFilter = this.dateFilterState;
  } else {
    this.dateFilter = new DateFilterState({ state });
  }

  this.dateFilter.on('changed', this.onDateFilterStateChanged, this);

  if (this.filterAgent) {
    this.filterAgent.on('changed', this.onFilterStateChanged, this);
  }
}

/* @this Dashboard */
function updateCardContent({
  card,
  isInViewPort,
  fetchSingleTile = false,
  currentCampaign,
  onMounted = null,
}) {
  const {
    name,
    contentType,
    constructOptions,
  } = this.cardState.getCardAttrByTypeId(card.id);

  this.config.getContentConstructor({
    contentType,
    constants,
    instrumentation,
    state,
    config,
    pageContext,
    onMounted,
    edmCampaign: edm,
  }).then(({ contentConstructor, deps }) => {
    if (!contentConstructor || this.removed) {
      return;
    }

    const cardId = _.findKey(this.cardMaps, item => item.typeId === card.id);
    const content = createCardContentInstance.call(this, contentConstructor, _.extend({
      name,
      constructOptions,
      fetchSingleTile,
      typeId: card.id,
      isInViewPort,
      container: this.cardPanel.cards[cardId].getContentContainer(),
      deps: {
        ...deps,
        azure: azureUrlRewrite,
        localInstrumentation,
        cacheManager,
      },
      sharedOptions: {
        getCardsConfig: () => this.cardState.cards,
      },
      currentCampaign,
      scope: this.scope,
      newI18n: this.newI18n,
      preferenceService: this.preferenceService,
    }, this.savedStates, card.options));

    this.cardMaps[cardId].content = content;
    this.cardPanel.updateContent(cardId, content);
  });
}

export class Dashboard extends Backbone.View {
  initialize({
    perfMarker,
    dateFilterState,
    filterAgent,
    currentCampaign,
    newCardsConfig,
    welcomeCardsConfig,
    pageName,
    onMounted,
    scope,
    accountsMode,
    newI18n,
    preexecuteFlag = false,
    preferenceService,
  }) {
    this.preferenceService = preferenceService;
    this.currentCampaign = currentCampaign;
    this.perfMarker = perfMarker;
    if (state.get('campaign_id')) {
      this.navigationLevel = 'campaign';
    } else if (state.get('account_id')) {
      this.navigationLevel = 'account';
    } else {
      this.navigationLevel = 'customer';
    }
    this.dateFilterState = dateFilterState;
    this.filterAgent = filterAgent;
    this.pageName = pageName;
    this.onMounted = onMounted;
    this.scope = scope;
    this.newI18n = newI18n;
    this.legacyI18n = buildLegacyI18n(this.newI18n, i18nMappings);
    this.accountsMode = accountsMode;
    this.getCardsConfig = newCardsConfig;

    // Setup card state manager
    this.cardState = new CardState({
      navigationLevel: this.navigationLevel,
      pageContext,
      odata,
      edm,
      preferences,
      permissions,
      instrumentationSettings,
      instrumentation,
      constants,
      newCardsConfig,
      welcomeCardsConfig,
      accountsMode,
      campaignType: this.campaignType,
    });

    // Initial load of the card state (from preference)
    this.p$CardState = this.cardState.fetch().then(() => {
      // Remember the dashboard ID assigned by CardState
      this.dashboardId = this.cardState.get('dashboardId');
    });

    // Use this array as a state queue
    this.state = [];
    this.savedStates = {};
    this.dispatched = false;

    this.preexecuteFlag = preexecuteFlag;
  }

  get campaignType() {
    let campaignType = this.filterAgent && this.filterAgent.campaignType;
    if (this.currentCampaign) {
      campaignType = _.chain(this.currentCampaign).result('CampaignType').value();
    }
    return campaignType;
  }

  get className() {
    return 'dashboard';
  }

  get events() {
    return {
      'click .dashboard__new-tile-banner a.show-new-tile': this.showNewTile,
      'click .dashboard__new-tile-banner .msg-dismiss-button': this.hideNewTileBannerClicked,
      'click .mcc_too_many-accounts a': this.gotoManagementTab,
    };
  }

  onDateFilterStateChanged({ dateRange }) {
    // Dispatch the new dateRange state to children cards.
    this.state.push({ dateRange });
    this.dispatchStateAsync();
  }

  onFilterStateChanged({ filter, campaignType }) {
    this.state.push({ filter, campaignType });
    this.dispatchStateAsync();
  }

  saveInitialState(initialState) {
    this.savedStates = initialState;
  }

  dispatchStateAsync() {
    // Only async dispatch one time until the sync dispatchment finishes
    if (!this.dispatched) {
      _.defer(() => {
        this.dispatchState();
        this.dispatched = false;
      });
      this.dispatched = true;
    }
  }

  dispatchState() {
    if (this.state.length === 0) {
      return;
    }

    // Merge the state queue
    const states = _.reduce(
      this.state,
      (memo, item) => _.extend(memo, item)
    );

    // dispatch all states to cards
    _.each(this.cardMaps, (card) => {
      if (card.content) {
        card.content.updateState(states);
      }
    });

    // Save all the states for being used as initial states while adding new cards.
    this.savedStates = _.extend(this.savedStates, states);

    // Also add a log
    quickInstrumentation(
      'OverviewPageLoadData',
      `WithFilter: ${!_.isEmpty(this.savedStates.filter) && !_.isEmpty(this.savedStates.filter.query)}; WithPoP: ${!_.isEmpty(this.savedStates.dateRange) && !_.isEmpty(this.savedStates.dateRange.compared)}`
    );

    // Clear the queue
    this.state.length = 0;
  }

  setupToolbar() {
    if (this.config.toolbar) {
      // Toolbar could be dynamically created and removed based on current context
      if (this.toolbar) {
        this.toolbar.remove();
      }

      const toolbarItems = _.map(this.config.toolbar.items, item => _.extend(item, {
        text: i18n.getString(item.textKey),
      }));

      this.toolbar = new ToolbarView({
        toolbarId: _.uniqueId('dashboard-toolbar-'),
        items: toolbarItems,
      }).render();

      // Setup the 'add card' button
      this.toolbar.update({
        id: this.config.toolbar.ids.addCardButton,
        onClick: showAddCardView.bind(this),
        iconLeft: ['glyphicon', 'toolbar-icon', 'toolbar-icon-left', 'glyphicon-plus'],
      });

      this.$('.dashboard__toolbar').append(this.toolbar.el);
    }
  }

  setupCardPanel() {
    // CardState is already ready.
    this.cardAttrsArray = _.map(this.cardState.cards, (card) => {
      const {
        titleKey,
        sizeOption,
        preDefinedMenuItems,
        useNewI18n,
      } = this.cardState.getCardAttrByTypeId(card.id);
      let title = '';
      if (titleKey) {
        title = useNewI18n ? this.newI18n.getString(titleKey) : i18n.getString(titleKey);
      }
      return {
        typeId: card.id,
        title,
        sizeOption,
        options: card.options,
        preDefinedMenuItems,
      };
    });
    this.cardPanel = new CardPanel({
      config: _.defaults({
        dragAndDrop: this.config.defaultDragAndDrop,
        debug: this.config.defaultDebug,
        dragHandlerSelector: this.config.defaultDragHandlerSelector,
      }),
      i18n: this.legacyI18n,
      layoutOptions: this.config.layoutOptions,
      initialWidth: $('.overview-page').innerWidth() - newUIWidthPaddingsAndOffSet,
    }).render();

    // Add initial cards to the panel
    const orders = this.cardPanel.add(_.map(this.cardAttrsArray, attr => _.chain(attr).pick(['title', 'content', 'sizeOption']).extend({ showMenuIcon: _.size(attr.preDefinedMenuItems) > 0 }).value()), { silent: true });

    // Save the initial order information
    this.cardMaps = {};
    _.map(orders, (id, index) => {
      this.cardMaps[id] = this.cardAttrsArray[index];
    }, this);

    // Check how many cards fits in the viewport
    this.viewportCardsCount = getViewportCardCount({
      config: this.config,
      cards: this.cardState.cards,
      wunderbarState,
      instrumentation,
      constants,
      isMccLevel: false,
    });
    this.remainingViewportCards = _.chain(this.cardState.cards)
      .first(this.viewportCardsCount)
      .pluck('id')
      .value();

    if (_.isEmpty(this.remainingViewportCards)) {
      this.perfMarker.done({ ViewportCardCount: this.viewportCardsCount });
      PageReady.pageIsReady(this.pageName);
    }

    if (this.config.defaultName !== 'welcome') {
      this.setupFooter();
    }

    // Hook the card-panel events
    this.cardPanel.on('card-orderchanged', () => {
      const originalOrder = _.pluck(this.cardState.cards, 'id');
      const newOrder = _.map(this.cardPanel.cardsOrder, id => this.cardMaps[id].typeId);

      quickInstrumentation('ReorderTile', `Original order: ${originalOrder.join(', ')}. New order: ${newOrder.join(', ')}.`);
      _.defer(saveSelectedCardsState.bind(this));
      this.hideNewTileBanner();
    });

    this.cardPanel.on('add-requested', () => {
      showAddCardView.call(this, { fromTile: true });
    }, this);

    this.cardPanel.on('card-added', (e) => {
      const typeIds = _.map(
        e.ids,
        id => (_.has(this.cardMaps, id) ? this.cardMaps[id].typeId : null)
      );

      quickInstrumentation('AddTileToOverview', _.compact(typeIds));

      // Note: do nothing here, adding card is only triggered from dashboard, no need to
      // update cardMaps. Save the new card order to preference.
      _.defer(saveSelectedCardsState.bind(this));

      this.hideNewTileBanner();
    }, this);

    this.cardPanel.on('card-resized', (e) => {
      quickInstrumentation('ResizeTile');

      // Card size option should be saved as user preference
      if (_.has(this.cardMaps, e.id)) {
        this.cardMaps[e.id].sizeOption = this.cardMaps[e.id].sizeOption || {};
        this.cardMaps[e.id].sizeOption[e.key] = this.cardMaps[e.id].sizeOption[e.key] || {};
        this.cardMaps[e.id].sizeOption[e.key].width = e.width;

        _.defer(saveSelectedCardsState.bind(this));
      }
    }, this);

    this.cardPanel.on('card-deleted', (e) => {
      const typeIds = _.map(e.ids, (id) => {
        let typeId = _.has(this.cardMaps, id) ? this.cardMaps[id].typeId : null;

        if (typeId === 'CardType-Tips') {
          if (this.navigationLevel === 'account') {
            typeId = 'CardType-Tips-And-Recommendations';
          } else {
            typeId = 'CardType-Recommendations';
          }
        }

        return typeId;
      });

      quickInstrumentation('RemoveTileFromOverview', _.compact(typeIds));
      // Card deletion could be triggered from card holder toolbar.
      // Remove the entry from local cardMaps first

      _.each(e.ids, (id) => {
        if (_.has(this.cardMaps, id)) {
          delete this.cardMaps[id];
        }
      }, this);

      // Save the new card order
      _.defer(saveSelectedCardsState.bind(this));
      this.hideNewTileBanner();
    }, this);

    this.$('.dashboard__card-panel').append(this.cardPanel.$el);
    _.defer(() => {
      this.cardPanel.trigger('attached');
    });

    // Load cards in the viewport.
    _.each(_.first(this.cardState.cards, this.viewportCardsCount), (card) => {
      updateCardContent.call(this, {
        card,
        onMounted: this.onMounted,
        isInViewPort: true,
        currentCampaign: this.currentCampaign,
      });
    });

    // Function to load cards outside the initial viewport
    const loadCardsOutSizeViewPort = _.once(() => {
      if (this.removed) {
        return;
      }

      _.each(
        _.last(this.cardState.cards, this.cardState.cards.length - this.viewportCardsCount),
        (card) => {
          updateCardContent.call(this, {
            card,
            isInViewPort: false,
            currentCampaign: this.currentCampaign,
          });
        }
      );
    });

    const dismissOverviewFluctuationPopup = () => dismissPopupIfExist(document.getElementsByClassName('mcc-perf-fluctuation-placeholder'));
    PageReady.afterPageReady().then(() => {
      if (!this.removed) {
        loadCardsOutSizeViewPort.call(this);
        _.each(_.keys(this.cardMaps), (key) => {
          this.cardPanel.updatePreDefinedMenuItems(key, this.cardMaps[key].preDefinedMenuItems);
        });

        const windowScrollLayout = document.querySelector('.app-content-body');
        const topChangeCardScrollLayout = document.querySelector('.top-change-grid-container');

        if (windowScrollLayout) {
          windowScrollLayout.parentNode.addEventListener('scroll', dismissOverviewFluctuationPopup);
        }

        if (topChangeCardScrollLayout) {
          topChangeCardScrollLayout.addEventListener('scroll', dismissOverviewFluctuationPopup);
        }
      }
    });

    this.windowEventHandler = () => {
      loadCardsOutSizeViewPort.bind(this)();
      dismissOverviewFluctuationPopup();
    };
    window.addEventListener('scroll', this.windowEventHandler);
    window.addEventListener('resize', this.windowEventHandler);
    $('.overview-page').parent().on('scroll', loadCardsOutSizeViewPort.bind(this));
  }

  addCard(typeIds) {
    if (!_.isArray(typeIds) || typeIds.length === 0) {
      return;
    }

    const cardAttrs = _.map(typeIds, (typeId) => {
      const {
        titleKey,
        sizeOption,
        preDefinedMenuItems,
      } = this.cardState.getCardAttrByTypeId(typeId);

      return {
        title: titleKey ? i18n.getString(titleKey) : '',
        sizeOption,
        preDefinedMenuItems,
      };
    });

    const cardIds = this.cardPanel.add(cardAttrs);

    _.each(cardIds, (cardId, index) => {
      // Keep the card attrs in the map.
      this.cardMaps[cardId] = _.extend({}, {
        typeId: typeIds[index],
        title: cardAttrs[index].title,
        sizeOption: cardAttrs[index].sizeOption,
        preDefinedMenuItems: cardAttrs[index].preDefinedMenuItems,
      });
    });

    _.each(typeIds, (typeId) => {
      updateCardContent.call(this, {
        card: { id: typeId },
        isInViewPort: false,
        fetchSingleTile: true,
        currentCampaign: this.currentCampaign,
      });
    });
  }

  deleteCard(typeIds) {
    if (!_.isArray(typeIds) || typeIds.length === 0) {
      return;
    }

    const cardIds = _.map(
      typeIds,
      typeId => _.findKey(this.cardMaps, item => item.typeId === typeId)
    );

    // card panel will remove the card content view and raise 'card-deleted' event back when done
    this.cardPanel.delete(cardIds);
    PageReady.pageIsReady(this.pageName);
  }

  setupNewTileNotice() {
    if (this.cardState.newDefaultOutCardsAvailable) {
      this.$(`#${this.config.toolbar.ids.addCardButton}`).append(newFeatureTemplate({ i18n }));
      quickInstrumentation('AddNewTilesToOverview', 'New! icon shown in Add Tiles button for new default out cards');
    }
    if (this.cardState.newDefaultInCards) {
      let newTileDesc;

      if (this.cardState.newDefaultInCards.length > 2) {
        newTileDesc = i18n.getString('Dashboard_NewTiles', this.cardState.newDefaultInCards.length);
      } else if (this.cardState.newDefaultInCards.length === 2) {
        const { addCardTitleKey: title1Key } =
          this.cardState.getCardAttrByTypeId(this.cardState.newDefaultInCards[0]);
        const { addCardTitleKey: title2Key } =
          this.cardState.getCardAttrByTypeId(this.cardState.newDefaultInCards[1]);

        newTileDesc = i18n.getString('Dashboard_Two_Tiles', i18n.getString(title1Key), i18n.getString(title2Key));
      } else if (this.cardState.newDefaultInCards.length === 1) {
        const { addCardTitleKey: titleKey } =
          this.cardState.getCardAttrByTypeId(this.cardState.newDefaultInCards[0]);

        newTileDesc = i18n.getString('Dashboard_Tile', i18n.getString(titleKey));
      }

      const newTileMsg = i18n.getString('Dashboard_NewTileMsg', newTileDesc);
      const newTileBannerContainer = this.$('.dashboard__new-tile-banner');

      newTileBannerContainer.html(newTileBannerTemplate({
        i18n,
        newTileMsg,
      }));

      this.newTileId = _.last(this.cardState.newDefaultInCards);
      quickInstrumentation('AddNewTilesToOverview', `Show new tile banner for ${this.cardState.newDefaultInCards.join(', ')}`);
    }
  }

  setupFooter() {
    const timeZoneId = config.get('AccountTimeZone');
    const footerContainer = this.$('.summarypage-bifreshtime');
    const accountTimeZoneText = i18nGlobal.getString(`TimeZoneId_${timeZoneId}`);

    footerContainer.html(footerTemplate({
      i18n,
      accountTimeZoneText,
      appendLearnMoreLink,
    }));
  }

  setupTooManyAccountsWarning(dateRange) {
    if (this.navigationLevel !== 'customer') {
      return;
    }

    let tiles;

    if (_.isEmpty(this.cardState.cards)) {
      // Corner case if the user removed call tiles.
      // If theres no tiles. Add one to get MT response.
      tiles = ['Device'];
    }

    fetchMCCOverview({
      entitySet: edm.currentCustomer.Accounts,
      dateRange,
      jsdata,
      dateUtil,
      tiles,
      getCardsConfig: () => this.cardState.cards,
      instrumentation,
      constants,
      permissions,
      accountsMode: this.accountsMode,
    }).then((res) => {
      let showTooMuchDataError = false;
      if (_.some(res.errors, error => error.Code === 'TooMuchDataToDownload')) {
        showTooMuchDataError = true;
      }

      if (showTooMuchDataError) {
        this.$('.dashboard__new-tile-banner').html('');
        this.$('.dashboard__toolbar').html('');
        this.$('.dashboard__card-panel').html('');

        const warningContainer = this.$('.mcc_too_many-accounts');
        const managementLink = legacyRouter.getRouteUrl('accounts_management');
        const linkContent = `<a href="${managementLink}">${i18n.getString('Dashboard_ManagementTab')}</a>`;
        const warning = i18n.getString('Dashboard_TooManyAccounts', linkContent);

        warningContainer.append(tooManyAccountTemplate({ warning }));
        PageReady.pageIsReady(this.pageName);
      }
    });
  }

  render() {
    this.$el.html(template({}));

    _.delay(() => {
      if (!this.removed) {
        quickInstrumentation('QualifiedVisitOverviewPageFromCampaign', `QualifiedOverviewPageVisit: ${this.navigationLevel}`);
      }
    }, 5000);

    this.p$CardState.then(() => {
      this.config = this.cardState.config;

      // Setup toolbar
      this.setupToolbar();

      if (this.config.defaultName === 'welcome') {
        this.setupCardPanel();
        // no dragNdrop for welcome tips, which only has one tile, without add/remove.
        this.cardPanel.$('.card-holder__toolbar').css('cursor', 'default');
      } else {
        setUpAgents.call(this);

        // Setup card-panel
        this.p$ReadyState = Promise.all([
          this.dateFilter.p$State,
        ]).spread((dateRange) => {
          this.saveInitialState({
            dateRange,
            filter: this.filterAgent ? this.filterAgent.filter : undefined,
            campaignType: this.filterAgent ? this.filterAgent.campaignType : undefined,
          });
          this.setupCardPanel();
          this.setupNewTileNotice();
          if (!this.preexecuteFlag) {
            this.setupTooManyAccountsWarning(dateRange);
          }
        });
      }
    });

    return this;
  }

  showNewTile() {
    _.find(this.cardMaps, card => card.typeId === this.newTileId).content.el.scrollIntoView({ behavior: 'smooth' });
    quickInstrumentation('AddNewTilesToOverview', 'The show me button clicked in new tiles banner');
  }

  hideNewTileBanner() {
    this.$('.dashboard__new-tile-banner').hide();
  }

  hideNewTileBannerClicked() {
    this.hideNewTileBanner();
    quickInstrumentation('AddNewTilesToOverview', 'The hide banner button clicked in new tiles banner');
  }

  gotoManagementTab(event) {
    if (event && (event.button !== 0 ||
    event.ctrlKey ||
    event.shiftKey ||
    event.altKey ||
    event.metaKey)) {
      return true;
    }

    legacyRouter.navigateToRoute('accounts_management');
    return false;
  }

  remove() {
    if (this.toolbar) {
      this.toolbar.remove();
    }

    if (this.addCardView) {
      this.addCardView.remove();
    }

    if (this.cardPanel) {
      this.cardPanel.remove();
    }

    if (this.windowEventHandler) {
      window.removeEventListener('scroll', this.windowEventHandler);
      window.removeEventListener('resize', this.windowEventHandler);
    }

    this.removed = true;

    super.remove();
  }
}
